module.exports = __webpack_public_path__ + "src/assets/games/32/66.jpg";